<template>
  <i
    :class="`fa cfa-${dasherize(tipo)}`"
    :data-toggle="showTooltip ? 'tooltip' : ''"
    :title="humanEnumName('alumno_asistencia', 'tipo', underscore(tipo))"
  >
  </i>
</template>

<script>
import humanEnumName from '../../../libs/i18n';
import { dasherize, underscore } from '../../../libs/strings';

export default {
  props: {
    tipo: { type: String, required: true },
    showTooltip: { type: Boolean, default: true },
  },
  methods: {
    humanEnumName, dasherize, underscore,
  },
};
</script>
